import { $, $$ } from "../libraries/utils"
import { defaultZoom, pinchZoom } from "./pinch-zoom"
import wheelZoom from "../libraries/wheel-zoom"
import Swiper, { Navigation, Pagination, Autoplay, FreeMode } from 'swiper'

window.isZoomSliderInitialized = false

window.zoomImageSlider = (selectedIndex, isWheelZoom) => {

    if (selectedIndex == null)
        selectedIndex = 0;

    const $zoomSliderContainer = $(".js-swiper-zoom-image-slider")
    if (!$zoomSliderContainer) {
        return
    }

    if (!window.isZoomSliderInitialized) {
        window.fullsizeImagesProductsSlider = new Swiper( ".swiper-zoom-image", {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                },
            },
            slideClass: 'js-add-pinchzoom',
            freeMode: true,
            simulateTouch: false,
            rewind: true,
            on: {
                init: function() {
                    window.isZoomSliderInitialized = true

                    setTimeout(function() {
                        $$(".js-add-pinchzoom").forEach((element) => pinchZoom(element))
                        $$(".js-add-wheel-zoom").forEach((img) => wheelZoom()(img))
                    }, 50)

                },
                transitionEnd: function() {
                    defaultZoom()
                }
            }
        })
    }


    window.fullsizeImagesProductsSlider.slideTo(selectedIndex);

}
